module.exports = __webpack_public_path__ + "img/chart.7d6e21ea.png";